<div class="filter-panel">
  <div class="filter-panel__toolbar">
    <button class="btn btn-add-filter" type="button" [disabled]="!filters" (click)="openSideBar()">
      <img src="assets/icons/filter.svg" alt="filter" />{{ 'CHANGE_FILTER_BTN' | translate }}
    </button>
  </div>

  <astral-layout-group
    class="filter-panel__fields"
    [columns]="6"
    [tabletColumns]="4"
    [mobileColumns]="2"
    [columnGap]="'16px'"
    [rowGap]="'var(--astral-filter-row-gap, 0px)'"
  >
    <ng-container #container></ng-container>
  </astral-layout-group>
</div>

<ng-template #date let-control="control">
  <astral-date-picker
    class="filter-item"
    [control]="control"
    [clearOthers]="true"
    [filterActions]="true"
    (addonClick)="clearOtherFilters(control)"
    (clearClick)="clearFilter(control)"
  ></astral-date-picker>
</ng-template>
<ng-template #dateTime let-control="control">
  <astral-date-picker
    class="filter-item"
    [control]="control"
    [clearOthers]="true"
    [filterActions]="true"
    (addonClick)="clearOtherFilters(control)"
    (clearClick)="clearFilter(control)"
  ></astral-date-picker>
</ng-template>
<ng-template
  #select
  let-control="control"
  let-itemsSource="itemsSource"
  let-allowMultipleSelection="allowMultipleSelection"
  let-openAtValue="openAtValue"
  let-visibleOptionCount="visibleOptionCount"
>
  <astral-select
    class="filter-item"
    [control]="control"
    [itemsSource]="itemsSource"
    [multiple]="allowMultipleSelection"
    [openAtValue]="openAtValue"
    [visibleOptionCount]="visibleOptionCount"
    [clearOthers]="true"
    [filterActions]="true"
    (addonClick)="clearOtherFilters(control)"
    (clearClick)="clearFilter(control)"
  ></astral-select>
</ng-template>
<ng-template #text let-control="control" let-placeholderText="placeholderText">
  <astral-input
    class="filter-item"
    [control]="control"
    [placeholderText]="placeholderText"
    [clearOthers]="true"
    [filterActions]="true"
    (addonClick)="clearOtherFilters(control)"
    (clearClick)="clearFilter(control)"
  ></astral-input>
</ng-template>
<ng-template
  #remotefilter
  let-control="control"
  let-service="autoCompleteService"
  let-serviceOptions="serviceOptions"
  let-updateOnOptionsChange="updateOnOptionsChange"
  let-enableInfiniteScroll="enableInfiniteScroll"
>
  <app-autocomplete-remote-paged
    class="filter-item filter-item--legacy"
    [control]="control"
    [service]="service"
    [defaultSearch]="'*'"
    [serviceOptions]="serviceOptions"
    [updateOnOptionsChange]="updateOnOptionsChange"
    [enableInfiniteScroll]="enableInfiniteScroll"
    [clearOthers]="true"
    [filterActions]="true"
    (addonClick)="clearOtherFilters(control)"
    (clearClick)="clearFilter(control)"
  ></app-autocomplete-remote-paged>
</ng-template>
<ng-template
  #remoteMultiFilter
  let-control="control"
  let-service="autoCompleteService"
  let-serviceOptions="serviceOptions"
  let-updateOnOptionsChange="updateOnOptionsChange"
>
  <astral-remote-multi-select
    class="filter-item"
    [control]="control"
    [service]="service"
    [defaultSearch]="'*'"
    [serviceOptions]="serviceOptions"
    [updateOnOptionsChange]="updateOnOptionsChange"
    [clearOthers]="true"
    (addonClick)="clearOtherFilters(control)"
    (clearClick)="clearFilter(control)"
  ></astral-remote-multi-select>
</ng-template>

<app-list-management-sidebar
  [open]="isChangeColumnsSidebarOpen"
  type="filters"
  [defaultFilters]="defaultFilters"
  [items]="filters"
  [title]="'CHANGE_FILTER_BTN'"
  [searchCaption]="'SEARCH_FILTERS'"
  (onSave)="edit($event)"
  (onCancel)="sideBarCancel()"
>
</app-list-management-sidebar>
